import Lottie from 'lottie-react';

import signOffTodo from '../jsons/Sign-Off-Todo.json';

const SignOffTodo = props => {
  return <Lottie loop={false} animationData={signOffTodo} {...props} />;
};

export default SignOffTodo;
